/* 布局 */
//前台
import Layout from "@views/layout";

const memberRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "member/list",
        name: "MEMBER",
        meta: {
            title: "会员管理",
        },
        component: () => import("@views/business/member/index.vue"),
    },
        ],
};

export default memberRouter;
